"use strict";

import getCurrentLp from "../util/getCurrentLp";

let url = document.location.href;
let isMeuVivo = url.indexOf("cliente-especial-meuvivo") > -1;
let isDoubleRedes = url.search(/doubleredes=true/gi) > -1;
let isPortabilidade = url.search(/movimento=portabilidade/gi) > -1;
let is29M = url.search(/plano=29M/gi) > -1;
let params = new URLSearchParams(window.location.search);

const paramsPlan = (params.get("plano") && params.get("plano").toUpperCase()) || "49M";
const paramAction = params.get("acao");
const regional = params.get("regional") || "nacional";
const isAction = paramAction === "vivopay3";

let groups = require("../regionalization/cards.json");

let offer = false;
const infosBanner = {};

if (isDoubleRedes) {
  infosBanner.titulo = "Agora com o <strong>Youtube</strong> no pacote de redes sociais e vídeo!";
  infosBanner.icone = "./assets/img/header-instagram.png";
  infosBanner.textoAlternativo =
    "Composição de logos dos aplicativos Youtube, Facebook, TikTok e outros";
  infosBanner.background = "#461E5F";
  infosBanner.backPreco = "#CD1E5A";
  infosBanner.precoColor = "#fff";
  infosBanner.ctaClassColor = "white";
  infosBanner.divisor = "separador-plus-insta";
}

if (!isDoubleRedes) {
  infosBanner.titulo = "E você ainda ganha R$200 em Vale Bonus";
  infosBanner.icone = "./assets/img/header-icons-vale-bonus.png";
  infosBanner.textoAlternativo = "Images com os logos dos beneficio Vale Bonus";
  infosBanner.background = "#660099";
  infosBanner.backPreco = "#FAB437";
  infosBanner.precoColor = "#660099";
  infosBanner.ctaClassColor = "";
  infosBanner.divisor = "separador-plus-amazon";
}

const skeletonBanner = {
  "29M": {
    id: "29M",
    giga_full: 6,
    preco: {
      real: 29,
      centavos: 99,
    },
    doubleredes: {
      giga_full: 9,
      preco: {
        real: 34,
        centavos: 99,
      },
      dados_plano: [
        {
          titulo: "3GB + 3GB na Fatura Digital + 3GB para redes sociais",
        },
      ],
    },
    dados_plano: [
      {
        titulo: "3GB + 3GB na Fatura Digital",
        titulo_oferta: "6GB",
      },
    ],
    app: {
      titulo: infosBanner.titulo,
      icone: infosBanner.icone,
      textoAlternativo: infosBanner.textoAlternativo,
      fl_apps: true,
    },
    link: "https://lojaonline.vivo.com.br/checkout-express/selecao?site=vivo&plan=105008282",
    linkM: "https://lojaonline.vivo.com.br/checkout-express/selecao?site=vivo&plan=105008282",
    sku: "VIVOCTRLF79N",
    package: "",
    packageDR: "",
    action: "&action=exchange",
  },
  "34M": {
    id: "34M",
    giga_full: 7,
    preco: {
      real: 34,
      centavos: 99,
    },
    doubleredes: {
      giga_full: 11,
      preco: {
        real: 39,
        centavos: 99,
      },
      dados_plano: [
        {
          titulo: "4GB + 3GB na Fatura Digital + 4GB para redes sociais",
        },
      ],
    },
    dados_plano: [
      {
        titulo: "4GB + 3GB na Fatura Digital",
        titulo_oferta: "7GB",
      },
    ],
    app: {
      titulo: infosBanner.titulo,
      icone: infosBanner.icone,
      textoAlternativo: infosBanner.textoAlternativo,
      fl_apps: true,
    },
    link: "https://lojaonline.vivo.com.br/checkout-express/selecao?site=vivo&plan=105008302",
    linkM: "https://lojaonline.vivo.com.br/checkout-express/selecao?site=vivo&plan=105008302",
    sku: "VIVOCTRLF55N",
    package: "",
    packageDR: "",
    action: "",
  },
  "39M": {
    id: "39M",
    giga_full: 8,
    preco: {
      real: 39,
      centavos: 99,
    },
    doubleredes: {
      giga_full: 13,
      preco: {
        real: 44,
        centavos: 99,
      },
      dados_plano: [
        {
          titulo: "5GB + 3GB na Fatura Digital + 5GB para redes sociais ",
        },
      ],
    },
    dados_plano: [
      {
        titulo: "5GB + 3GB na Fatura Digital",
        titulo_oferta: "8GB",
      },
    ],
    app: {
      titulo: infosBanner.titulo,
      icone: infosBanner.icone,
      textoAlternativo: infosBanner.textoAlternativo,
      fl_apps: true,
    },
    link: "https://lojaonline.vivo.com.br/checkout-express/selecao?site=vivo&plan=105008292",
    linkM: "",
    sku: "VIVOCTRLF47N",
    package: "",
    packageDR: "",
    action: "",
  },
  "49M": {
    id: "49M",
    giga_full: 20,
    preco: {
      real: 49,
      centavos: 99,
    },
    doubleredes: {
      giga_full: 28,
      preco: {
        real: 54,
        centavos: 99,
      },
      dados_plano: [
        {
          titulo: "8GB + 6GB de bônus* + 8GB para redes sociais <br/> +6GB de bônus Dia das Mães",
        },
      ],
    },
    dados_plano: [
      {
        titulo: "8GB + 6GB de bônus* <br/> +6GB de bônus Dia das Mães",
        titulo_oferta: "15GB",
      },
    ],
    app: {
      titulo: infosBanner.titulo,
      icone: infosBanner.icone,
      textoAlternativo: infosBanner.textoAlternativo,
      fl_apps: true,
    },
    link: "",
    linkM: "",
    sku: "44640499",
    package: "",
    packageDR: "",
    action: "",
  },
  "59M": {
    id: "59M",
    giga_full: 11,
    preco: {
      real: 59,
      centavos: 99,
    },
    doubleredes: {
      giga_full: 19,
      preco: {
        real: 64,
        centavos: 99,
      },
      dados_plano: [
        {
          titulo: "8GB + 3GB na Fatura Digital + 8GB para redes sociais",
        },
      ],
    },
    dados_plano: [
      {
        titulo: "8GB + 3GB na Fatura Digital",
        titulo_oferta: "11GB",
      },
    ],
    app: {
      titulo: infosBanner.titulo,
      icone: infosBanner.icone,
      textoAlternativo: infosBanner.textoAlternativo,
      fl_apps: true,
    },
    link: "https://lojaonline.vivo.com.br/checkout-express/selecao?site=vivo&plan=44640509",
    linkM: "https://lojaonline.vivo.com.br/checkout-express/selecao?site=vivo&plan=44640509",
    sku: "44640509",
    package: "",
    packageDR: "",
    action: "",
  },
  // "69D": {
  //   id: "69D",
  //   giga_full: 13,
  //   preco: {
  //     real: 69,
  //     centavos: 99,
  //   },
  //   doubleredes: {
  //     giga_full: 23,
  //     preco: {
  //       real: 74,
  //       centavos: 99,
  //     },
  //     dados_plano: [
  //       {
  //         titulo: "10GB + 3GB na Fatura Digital + 10GB para redes sociais ",
  //       },
  //     ],
  //   },
  //   dados_plano: [
  //     {
  //       titulo: "10GB + 3GB na Fatura Digital",
  //       titulo_oferta: "13GB",
  //     },
  //   ],
  //   app: {
  //     titulo: infosBanner.titulo,
  //     icone: infosBanner.icone,
  //     textoAlternativo: infosBanner.textoAlternativo,
  //     fl_apps: true,
  //   },
  //   link: "https://lojaonline.vivo.com.br/checkout-express/selecao?site=vivo&plan=44640549",
  //   linkM:
  //     "https://lojaonline.vivo.com.br/checkout-express/selecao?site=vivo&plan=44640549",
  //   sku: "44640549",
  //   package: "",
  //   packageDR: "",
  //   action: "",
  // },
  "69T": {
    id: "69T",
    giga_full: 13,
    preco: {
      real: 69,
      centavos: 99,
    },
    doubleredes: {
      giga_full: 23,
      preco: {
        real: 74,
        centavos: 99,
      },
      dados_plano: [
        {
          titulo: "10GB + 3GB na Fatura Digital + 10GB para redes sociais ",
        },
      ],
    },
    dados_plano: [
      {
        titulo: "10GB + 3GB na Fatura Digital",
        titulo_oferta: "13GB",
      },
    ],
    app: {
      titulo: "Curta mais de 90 milhões de músicas e 450 mil vídeos",
      icone: "./assets/img/logo-tidal.png",
      fl_apps: true,
    },
    link: "https://lojaonline.vivo.com.br/checkout-express/selecao?site=vivo&plan=44640559",
    linkM: "https://lojaonline.vivo.com.br/checkout-express/selecao?site=vivo&plan=44640559",
    sku: "44640559",
    package: "",
    packageDR: "",
    action: "",
  },
  "69N": {
    id: "69N",
    giga_full: 22,
    preco: {
      real: 69,
      centavos: 99,
    },
    doubleredes: {
      giga_full: 32,
      preco: {
        real: 74,
        centavos: 99,
      },
      dados_plano: [
        {
          titulo: "10GB + 6GB de bônus* + 10GB para redes sociais <br/> +6GB de bônus Dia das Mães",
        },
      ],
    },
    dados_plano: [
      {
        titulo: "10GB + 6GB de bônus* <br/> +6GB de bônus Dia das Mães",
        titulo_oferta: "13GB",
      },
    ],
    app: {
      titulo: "Seu plano Vivo com suas séries e filmes favoritos em apenas um clique.",
      icone: "./assets/img/logo-netflix.png",
      fl_apps: true,
    },
    link: "",
    linkM: "",
    sku: "44640559",
    package: "",
    packageDR: "",
    action: "",
  },
  "79M": {
    id: "79M",
    giga_full: 15,
    preco: {
      real: 79,
      centavos: 99,
    },
    doubleredes: {
      giga_full: 27,
      preco: {
        real: 84,
        centavos: 99,
      },
      dados_plano: [
        {
          titulo: "12GB + 3GB na Fatura Digital + 12GB para redes sociais",
        },
      ],
    },
    dados_plano: [
      {
        titulo: "12GB + 3GB na Fatura Digital  ",
        titulo_oferta: "15GB",
      },
    ],
    app: {
      titulo: infosBanner.titulo,
      icone: infosBanner.icone,
      textoAlternativo: infosBanner.textoAlternativo,
      fl_apps: true,
    },
    link: "https://lojaonline.vivo.com.br/checkout-express/selecao?site=vivo&plan=44640529",
    linkM: "https://lojaonline.vivo.com.br/checkout-express/selecao?site=vivo&plan=44640529",
    sku: "44640529",
    package: "",
    packageDR: "",
    action: "",
  },
};

let mountBanner = function (plan, normalParam = "", moreGB = 0) {
  let banner = skeletonBanner[plan],
    gbCard = banner.doubleredes.giga_full + moreGB,
    gbCardSemRedes = banner.giga_full + moreGB,
    textBanner;
  banner.double = isDoubleRedes;

  banner.offer = offer;
  banner.doubleredes.giga_full = `${gbCard}GB`;
  textBanner = `${gbCardSemRedes}GB`;
  banner.giga_full = textBanner.replace(".", ",");

  const numberPattern = /\d+/g;

  if (groups[regional]) {
    const cardFromURL = "card-" + paramsPlan;
    const group = groups[regional];

    let firstCard = group[Object.keys(group)][cardFromURL];

    if (isAction) {
      firstCard = group[Object.keys(group)][paramAction][cardFromURL];
    }

    if (firstCard.price && firstCard.priceComRedes) {
      const defaultPrice = firstCard.price.match(numberPattern);
      const doubleRedesPrice = firstCard.priceComRedes.match(numberPattern);

      banner.preco.real = defaultPrice[0];
      banner.preco.centavos = defaultPrice[1];

      banner.doubleredes.preco.real = doubleRedesPrice[0];
      banner.doubleredes.preco.centavos = doubleRedesPrice[1];
    }

    if (isDoubleRedes) {
      banner.link = firstCard.links[getCurrentLp()].doubleRedes;
    } else {
      banner.link = firstCard.links[getCurrentLp()].default;
    }
  }

  // if (isMeuVivo && !is29M) {
  //   banner.doubleredes.giga_full = `${gbCard + 2}GB`;
  //   textBanner = `${gbCardSemRedes + 2}GB`;
  //   banner.giga_full = textBanner.replace(".", ",");

  //   banner.dados_plano.push({ titulo: "+ 2GB de Bônus App Vivo*" });
  //   banner.doubleredes.dados_plano.push({
  //     titulo: "<br/>+ 2GB Bônus de App Vivo*",
  //   });

  //   gbCard = gbCard + 2;
  //   gbCardSemRedes = gbCardSemRedes + 2;
  // }

  if (isMeuVivo && paramsPlan === "49M") {
    gbCard = gbCard + 2;
    gbCardSemRedes = gbCardSemRedes + 2;
    banner.doubleredes.giga_full = `${gbCard}GB`;
    textBanner = `${gbCardSemRedes}GB`;
    banner.giga_full = textBanner.replace(".", ",");
    banner.dados_plano.push({ titulo: "<br/>+ 2GB de bônus especial" });
    banner.doubleredes.dados_plano.push({
      titulo: "<br/>+ 2GB de bônus especial",
    });
  }

  // if (!isDoubleRedes && isPortabilidade && paramsPlan === "49M") {
  //   gbCard = gbCard + 5;
  //   gbCardSemRedes = gbCardSemRedes + 5;
  //   banner.doubleredes.giga_full = `${gbCard}GB`;
  //   textBanner = `${gbCardSemRedes}GB`;
  //   banner.giga_full = textBanner.replace(".", ",");
  //   banner.dados_plano.push({ titulo: "<br/>+5GB bônus para Portabilidade**" });
  // }

  // if (isPortabilidade && paramsPlan === "49M" && isDoubleRedes) {
  //   gbCard = gbCard + 6;
  //   gbCardSemRedes = gbCardSemRedes + 6;
  //   banner.doubleredes.giga_full = `${gbCard}GB`;
  //   textBanner = `${gbCardSemRedes}GB`;
  //   banner.giga_full = textBanner.replace(".", ",");
  //   banner.dados_plano.push({ titulo: "<br/>+5GB bônus para Portabilidade**" });
  // }

  // if (isPortabilidade && (paramsPlan === "49M" || paramsPlan === "69N")) {
  //   gbCard = gbCard + 5;
  //   gbCardSemRedes = gbCardSemRedes + 5;
  //   banner.doubleredes.giga_full = `${gbCard}GB`;
  //   textBanner = `${gbCardSemRedes}GB`;
  //   banner.giga_full = textBanner.replace(".", ",");
  //   banner.dados_plano.push({ titulo: "+ 5GB Bônus Portabilidade*" });
  //   banner.doubleredes.dados_plano.push({ titulo: "+ 5GB Bônus Portabilidade*" });
  // }

  if (moreGB) {
    banner.dados_plano.push({
      titulo: ` + ${moreGB}GB de bônus por 12 meses**`,
    });
    banner.doubleredes.dados_plano.push({
      titulo: ` + ${moreGB}GB de bônus**`,
    });
  }

  // if (plan === "69D" && paramAction !== "migradotz") {
  //   banner.app.titulo = "Sua moeda para a vida render mais!";
  //   banner.app.icone = "./assets/img/header-dotz.png";
  //   banner.app.textoAlternativo = "Imagem de um texto estilizado que diz Dotz, você pode mais";
  // }

  // if (paramAction === "migradotz") {
  //   banner.dados_plano = [{ titulo: "" }];
  //   banner.doubleredes.giga_full = `${gbCard - moreGB}GB`;
  //   banner.giga_full = `${gbCardSemRedes - moreGB}GB`;
  //   document.querySelector(".banner--preco--cta--btn").innerHTML = "Assine já";
  // }

  // if (
  //   !isMeuVivo &&
  //   (paramAction === "vivopay1" ||
  //     paramAction === "vivopay2" ||
  //     paramAction === "vivopay3")
  // ) {
  //   banner.doubleredes.giga_full = `${gbCard + 6}GB`;
  //   banner.giga_full = `${gbCardSemRedes + 6}GB`;
  //   banner.dados_plano = [{ titulo: `${gbCardSemRedes}GB + 6GB de bônus*` }];
  //   banner.doubleredes.dados_plano = [
  //     {
  //       titulo: `${gbCardSemRedes}GB + 6GB de bônus* + ${
  //         gbCard - gbCardSemRedes
  //       }GB para redes sociais`,
  //     },
  //   ];
  // }

  return banner;
};

export default {
  titulo_aba: "Conheça o Plano Controle da Vivo",
  getData: () => {
    let dataBanners = "";

    if (!(url.search(/vantagens/gi) > -1)) {
      const banner = document.getElementsByClassName("banner")[0];
      const backPreco = document.getElementsByClassName("banner--preco")[0];
      const preco = document.getElementsByClassName("banner--preco--content")[0];
      const divisor = document.querySelector(".banner--separador--linha");
      const cta = document.querySelector(".banner--preco--cta");

      banner.style.backgroundColor = infosBanner.background;
      backPreco.style.backgroundColor = infosBanner.backPreco;
      preco.style.color = infosBanner.precoColor;
      divisor.style.backgroundColor = infosBanner.backPreco;

      if (infosBanner.ctaClassColor && infosBanner.ctaClassColor !== "") {
        cta.classList.add(infosBanner.ctaClassColor);
      }
    }

    switch (paramsPlan) {
      case "29M":
        dataBanners = "29M";
        if (isPortabilidade) dataBanners = "54A";
        break;
      case "34M":
        dataBanners = "34M";
        break;
      case "39M":
        dataBanners = "39M";
        break;
      case "49M":
        dataBanners = "49M";
        break;
      case "59M":
        dataBanners = "59M";
        break;
      // case "69D":
      //   dataBanners = "69D";
      //   break;
      case "69T":
        dataBanners = "69T";
        break;
      case "69N":
        dataBanners = "69N";
        break;
      case "79M":
        dataBanners = "79M";
        break;
      default:
        dataBanners = "49M";
        break;
    }

    return mountBanner(dataBanners);
  },
};
